import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.computedValor,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
      onChange: _ctx.defineValorSelecionado,
      class: "ss-tamanho-completo",
      disabled: _ctx.props.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_select_option, { value: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Amarela")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 2 }, {
          default: _withCtx(() => [
            _createTextVNode("Azul")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 3 }, {
          default: _withCtx(() => [
            _createTextVNode("Bege")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 4 }, {
          default: _withCtx(() => [
            _createTextVNode("Branca")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 5 }, {
          default: _withCtx(() => [
            _createTextVNode("Cinza")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 6 }, {
          default: _withCtx(() => [
            _createTextVNode("Dourada")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 7 }, {
          default: _withCtx(() => [
            _createTextVNode("Grená")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 8 }, {
          default: _withCtx(() => [
            _createTextVNode("Laranja")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 9 }, {
          default: _withCtx(() => [
            _createTextVNode("Marrom")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 10 }, {
          default: _withCtx(() => [
            _createTextVNode("Prata")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 11 }, {
          default: _withCtx(() => [
            _createTextVNode("Preta")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 12 }, {
          default: _withCtx(() => [
            _createTextVNode("Rosa")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 13 }, {
          default: _withCtx(() => [
            _createTextVNode("Roxa")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 14 }, {
          default: _withCtx(() => [
            _createTextVNode("Verde")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 15 }, {
          default: _withCtx(() => [
            _createTextVNode("Vermelha")
          ]),
          _: 1
        }),
        _createVNode(_component_a_select_option, { value: 16 }, {
          default: _withCtx(() => [
            _createTextVNode("Fantasia")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onChange", "disabled"])
  ]))
}